<template></template>

<script>
import axios from "axios";

export default {
  name: "startLocation",
  
  mounted() {
    const path = window.location.pathname;

    // Si es un recurso estático (js, css, imágenes, fuentes, etc.), no hacer nada
    const isStaticFile = /\.(js|css|png|jpg|jpeg|svg|woff2?|ttf|eot|ico|map)$/.test(path);
    const isStaticPath = path.startsWith('/js/') || path.startsWith('/css/') || path.startsWith('/img/') || path.startsWith('/fonts/');

    if (isStaticFile || isStaticPath) {
      return;
    }

    // Aquí sigue tu lógica normal de redirección
    const routeMap = {
      AR: '/ar/es/',
      CL: '/cl/es/',
      MX: '/mx/es/',
      ES: '/mx/es/',
      BR: '/mx/es/',
      UY: '/mx/es/',
      PE: '/mx/es/',
      CO: '/mx/es/',
      EC: '/mx/es/',
      US: '/us/es/',
    };

    const goToRoute = (country) => {
      const path = routeMap[country] || '/la/es/';
      this.$router.replace({
        path,
        params: {
          browserCountry: country.toLowerCase(),
          userLang: 'es'
        },
        name: 'homeLang'
      });
    };

    const savedCountry = localStorage.getItem('routeCountry');
    if (savedCountry) {
      goToRoute(savedCountry);
    } else {
      axios.get('https://ipapi.co/country/')
        .then(response => {
          const country = response.data?.toUpperCase() || 'LA';
          localStorage.setItem('routeCountry', country);
          goToRoute(country);
        })
        .catch(() => {
          localStorage.setItem('routeCountry', 'LA');
          goToRoute('LA');
        });
    }
  }
  }

</script>